import React from 'react';
import { Badge } from './ui/badge';
import { Camera } from 'lucide-react';

const OurWorkSection = () => {
  const projects = [
    {
      id: 1,
      image: "https://customer-assets.emergentagent.com/job_alf-embroidery/artifacts/58b6ecay_WhatsApp%20Image%202026-03-15%20at%2010.10.00%20PM%20%283%29.jpeg",
      title: "Eco Code Security",
      category: "Security Uniform",
      description: "Professional security polo with logo embroidery"
    },
    {
      id: 2,
      image: "https://customer-assets.emergentagent.com/job_alf-embroidery/artifacts/szkt57ly_WhatsApp%20Image%202026-03-15%20at%2010.10.00%20PM%20%282%29.jpeg",
      title: "Atyab Al Marshoud",
      category: "Corporate Uniform",
      description: "Grey jacket with bilingual back embroidery"
    },
    {
      id: 3,
      image: "https://customer-assets.emergentagent.com/job_alf-embroidery/artifacts/luoh8ty1_WhatsApp%20Image%202026-03-15%20at%2010.10.00%20PM%20%281%29.jpeg",
      title: "The Creations",
      category: "Branded Apparel",
      description: "Navy sweatshirt with precision white embroidery"
    },
    {
      id: 4,
      image: "https://customer-assets.emergentagent.com/job_alf-embroidery/artifacts/4ibr8fjn_WhatsApp%20Image%202026-03-15%20at%2010.09.59%20PM%20%281%29.jpeg",
      title: "Dar Khaifak Restaurant",
      category: "Restaurant Uniform",
      description: "Brown polo with Arabic logo embroidery"
    },
    {
      id: 5,
      image: "https://customer-assets.emergentagent.com/job_alf-embroidery/artifacts/88lnyt3n_WhatsApp%20Image%202026-03-15%20at%2010.09.59%20PM.jpeg",
      title: "Kolbat Restaurant",
      category: "Restaurant Uniform",
      description: "White t-shirt with flag and Arabic text printing"
    },
    {
      id: 6,
      image: "https://customer-assets.emergentagent.com/job_alf-embroidery/artifacts/lqsqctxb_WhatsApp%20Image%202026-03-15%20at%2010.09.56%20PM.jpeg",
      title: "Allaho Motors",
      category: "Corporate Uniform",
      description: "Grey shirt with orange logo and Arabic text"
    },
    {
      id: 7,
      image: "https://customer-assets.emergentagent.com/job_alf-embroidery/artifacts/x3r8f3fc_WhatsApp%20Image%202026-03-15%20at%2010.09.58%20PM%20%283%29.jpeg",
      title: "Love Diet Food",
      category: "Chef Uniform",
      description: "Green chef uniform with gold embroidery and chef hat"
    },
    {
      id: 8,
      image: "https://customer-assets.emergentagent.com/job_alf-embroidery/artifacts/q3lg1gkx_WhatsApp%20Image%202026-03-15%20at%2010.09.58%20PM%20%282%29.jpeg",
      title: "Wrap N Roll",
      category: "Restaurant Uniform",
      description: "Black t-shirt with bold yellow logo printing"
    },
    {
      id: 9,
      image: "https://customer-assets.emergentagent.com/job_alf-embroidery/artifacts/kjsaw65m_WhatsApp%20Image%202026-03-15%20at%2010.09.58%20PM%20%281%29.jpeg",
      title: "Whoopi Land",
      category: "Entertainment Uniform",
      description: "Navy and yellow staff uniform with colorful logo"
    },
    {
      id: 10,
      image: "https://customer-assets.emergentagent.com/job_alf-embroidery/artifacts/pkab1agg_WhatsApp%20Image%202026-03-15%20at%2010.09.58%20PM%20%284%29.jpeg",
      title: "Fox Protection",
      category: "Security Uniform",
      description: "Orange polo with shield logo embroidery"
    },
    {
      id: 11,
      image: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/83o59qtr_WhatsApp%20Image%202026-03-15%20at%2010.10.00%20PM.jpeg",
      title: "Kolbat Bait",
      category: "Restaurant Uniform",
      description: "Navy sweatshirt with gold Arabic calligraphy embroidery"
    },
    {
      id: 12,
      image: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/ebc2f7pa_WhatsApp%20Image%202026-03-15%20at%2010.09.58%20PM.jpeg",
      title: "Exzootic",
      category: "Entertainment Uniform",
      description: "Beige jacket with colorful wildlife DTF printing"
    },
    {
      id: 13,
      image: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/tdruxdmq_WhatsApp%20Image%202026-03-15%20at%2010.09.57%20PM%20%281%29.jpeg",
      title: "Bindousr Automotive",
      category: "Corporate Uniform",
      description: "Grey polo with back logo embroidery"
    },
    {
      id: 14,
      image: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/kr9m8ase_WhatsApp%20Image%202026-03-17%20at%205.05.10%20AM%20%282%29.jpeg",
      title: "Kaif Al Jawharah",
      category: "Corporate Uniform",
      description: "Beige polo with colorful diamond logo embroidery"
    },
    {
      id: 15,
      image: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/3oich1zp_WhatsApp%20Image%202026-03-17%20at%205.05.10%20AM%20%281%29.jpeg",
      title: "Oxygen Clean",
      category: "Cleaning Service",
      description: "Blue jacket with back logo embroidery"
    },
    {
      id: 16,
      image: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/d1cichso_WhatsApp%20Image%202026-03-17%20at%205.05.10%20AM.jpeg",
      title: "Medicals International",
      category: "Healthcare Uniform",
      description: "Green polo with white logo embroidery"
    },
    {
      id: 17,
      image: "https://customer-assets.emergentagent.com/job_651ffb38-388c-44ed-a90c-c9f123653714/artifacts/4m2mwvl0_WhatsApp%20Image%202026-04-14%20at%206.35.21%20PM.jpeg",
      title: "Power Wood",
      category: "Corporate Uniform",
      description: "Grey polo with Power Wood logo embroidery"
    },
    {
      id: 18,
      image: "https://customer-assets.emergentagent.com/job_651ffb38-388c-44ed-a90c-c9f123653714/artifacts/4u4e0lf5_WhatsApp%20Image%202026-04-14%20at%206.35.22%20PM%20%281%29.jpeg",
      title: "Play Kids Entertainment",
      category: "Entertainment Uniform",
      description: "Yellow polo with colorful Play logo embroidery"
    },
    {
      id: 19,
      image: "https://customer-assets.emergentagent.com/job_651ffb38-388c-44ed-a90c-c9f123653714/artifacts/3s7gbcc6_WhatsApp%20Image%202026-04-14%20at%206.35.22%20PM.jpeg",
      title: "IMS Corporation",
      category: "Corporate Uniform",
      description: "Grey hoodie with large IMS back logo printing"
    },
    {
      id: 20,
      image: "https://customer-assets.emergentagent.com/job_651ffb38-388c-44ed-a90c-c9f123653714/artifacts/ijpijtw4_WhatsApp%20Image%202026-04-14%20at%206.35.23%20PM%20%284%29.jpeg",
      title: "Noval Aluminum",
      category: "Industrial Uniform",
      description: "Grey sweatshirt with Arabic back printing"
    },
    {
      id: 21,
      image: "https://customer-assets.emergentagent.com/job_651ffb38-388c-44ed-a90c-c9f123653714/artifacts/6e8o6bl3_WhatsApp%20Image%202026-04-14%20at%206.35.23%20PM%20%283%29.jpeg",
      title: "The Spine Restaurant",
      category: "Restaurant Uniform",
      description: "Beige shirt with black apron and gold logo embroidery"
    }
  ];

  return (
    <section id="portfolio" className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center mb-4">
            <Badge className="bg-amber-600 text-white px-4 py-2 text-sm font-semibold">
              <Camera className="h-4 w-4 mr-2" />
              REAL PROJECTS
            </Badge>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Work Portfolio</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            See the quality and precision of our uniform customization for Kuwait's leading businesses
          </p>
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 max-w-5xl mx-auto">
          {projects.map((project) => (
            <div
              key={project.id}
              className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 bg-white"
            >
              {/* Image Container */}
              <div className="aspect-[3/4] overflow-hidden bg-slate-50 flex items-center justify-center p-2">
                <img
                  src={project.image}
                  alt={project.title}
                  className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Overlay on Hover */}
              <div className="absolute inset-0 bg-gradient-to-t from-blue-900 via-blue-900/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4">
                <Badge className="bg-white text-blue-900 w-fit mb-2 text-xs">
                  {project.category}
                </Badge>
                <h3 className="text-white text-sm font-bold mb-1">{project.title}</h3>
                <p className="text-blue-100 text-xs">{project.description}</p>
              </div>

              {/* Category Badge (Always Visible) */}
              <div className="absolute top-3 right-3 group-hover:opacity-0 transition-opacity duration-300">
                <Badge className="bg-blue-900 text-white shadow-lg text-xs">
                  {project.category}
                </Badge>
              </div>
            </div>
          ))}

          {/* Additional Info Card */}
          <div className="bg-gradient-to-br from-blue-900 to-blue-800 rounded-xl p-6 flex flex-col justify-center items-center text-center text-white">
            <Camera className="h-10 w-10 mb-3 text-blue-200" />
            <h3 className="text-lg font-bold mb-2">Your Project Could Be Next!</h3>
            <p className="text-blue-100 text-sm mb-4">
              Join our growing list of satisfied clients
            </p>
            <button
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-white text-blue-900 px-5 py-2 rounded-lg font-semibold text-sm hover:bg-gray-100 transition-colors duration-300"
            >
              Get Started
            </button>
          </div>
        </div>

        {/* Trust Indicator */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 text-lg">
            Trusted by <span className="font-bold text-blue-900">250+ businesses</span> for their uniform needs
          </p>
        </div>
      </div>
    </section>
  );
};

export default OurWorkSection;
